module.exports = __webpack_public_path__ + "img/eyyb-s3.e4622c2d.jpg";